import { AnimationDuration, HandSwap } from "@uno/protocol";
import { AnimationEffects, AnimationValue } from "../types/Animation";
import { getRoomLayoutSnapshot } from "utils/RoomLayout";

export const SWAP_HANDS_ANIMATION_ID = "swap-hands";

const ARC_OFFSET = 48;

const getSeatCenter = (playerId: string): { x: number, y: number } | null => {
    const seat = document.querySelector(`[data-player-id="${playerId}"]`);
    const anchor = seat?.querySelector("#player") ?? seat;

    if(!anchor) {
        return null;
    }

    const rect = anchor.getBoundingClientRect();

    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
};

const toTransform = ({ x, y }: { x: number, y: number }, scale: number): string => {
    return `translate(${x}px, ${y}px) translate(-50%, -50%) scale(${scale})`;
};

const SwapHandsAnimation = (swaps: Array<HandSwap>): AnimationValue => {
    const { discard } = getRoomLayoutSnapshot().scales;

    return {
        name: "swap-hands",
        duration: AnimationDuration.SwapHands,
        effects: () => swaps.reduce<Array<AnimationEffects>>((effects, swap, index) => {
            const from = getSeatCenter(swap.from);
            const to = getSeatCenter(swap.to);

            if(!from || !to) {
                return effects;
            }

            const length = Math.hypot(to.x - from.x, to.y - from.y) || 1;
            const middle = {
                x: (from.x + to.x) / 2 - ((to.y - from.y) / length) * ARC_OFFSET,
                y: (from.y + to.y) / 2 + ((to.x - from.x) / length) * ARC_OFFSET,
            };

            effects.push({
                el: `[data-hand-swap="${index}"]`,
                transform: [toTransform(from, discard * 0.45), toTransform(middle, discard * 0.85), toTransform(to, discard * 0.45)],
                opacity: [0, 1, 1, 0],
            });

            return effects;
        }, []),
        transitions: swaps.map(() => ({ duration: AnimationDuration.SwapHands, easing: "ease-in-out", fill: "forwards" })),
    };
};

export default SwapHandsAnimation;
